import React from 'react';
import Icon from '../../../components/AppIcon';

const ProjectStats = ({ projects }) => {
  const stats = [
    {
      label: 'Total Projects',
      value: projects?.length,
      icon: 'FolderOpen',
      color: 'text-accent'
    },
    {
      label: 'Live Projects',
      value: projects?.filter(p => p?.status === 'Live')?.length,
      icon: 'Globe',
      color: 'text-success'
    },
    {
      label: 'Technologies Used',
      value: [...new Set(projects.flatMap(p => p.technologies))]?.length,
      icon: 'Code2',
      color: 'text-warning'
    },
    {
      label: 'Industries Served',
      value: [...new Set(projects.map(p => p.industry))]?.length,
      icon: 'Building',
      color: 'text-primary'
    }
  ];

  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
      {stats?.map((stat, index) => (
        <div
          key={index}
          className="bg-card border border-border rounded-xl p-6 text-center hover:shadow-medium transition-all duration-300 group"
        >
          <div className={`w-12 h-12 mx-auto mb-3 bg-muted rounded-lg flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
            <Icon name={stat?.icon} size={24} className={stat?.color} />
          </div>
          <div className="text-2xl font-bold text-primary mb-1">{stat?.value}</div>
          <div className="text-sm text-muted-foreground">{stat?.label}</div>
        </div>
      ))}
    </div>
  );
};

export default ProjectStats;